export default __webpack_public_path__ + "static/media/3SIXT.9add0e62.svg";